// import React, { useEffect, useState } from "react";
// import { styled, useTheme } from "@mui/material/styles";
// import Box from "@mui/material/Box";
// import MuiDrawer from "@mui/material/Drawer";
// import MuiAppBar from "@mui/material/AppBar";
// import Toolbar from "@mui/material/Toolbar";
// import CssBaseline from "@mui/material/CssBaseline";
// import IconButton from "@mui/material/IconButton";
// import MenuIcon from "@mui/icons-material/Menu";
// import logo from "../assets/logo.png";
// import Cookies from "js-cookie";
// import toast from "react-hot-toast";

// import { Popover, Transition } from "@headlessui/react";

// import { useLocation, useNavigate } from "react-router-dom";
// import { IoIosArrowDown } from "react-icons/io";
// import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import Inventory2Icon from "@mui/icons-material/Inventory2";

// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import CleanHandsIcon from "@mui/icons-material/CleanHands";
// import PaidIcon from "@mui/icons-material/Paid";

// import {
//   SESSION_IS_AUTHENTICATED,
//   SESSION_USERINFO,
// } from "../Utills/Constants";
// //import { useDispatch } from "react-redux";
// import { MedicalInformation, PeopleAltRounded } from "@mui/icons-material";

// const drawerWidth = 300;

// const openedMixin = (theme) => ({
//   width: drawerWidth,
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen,
//   }),
//   overflowX: "hidden",
// });

// const closedMixin = (theme) => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: "hidden",
//   width: `calc(${theme.spacing(7)} + 1px)`,
//   [theme.breakpoints.up("sm")]: {
//     width: `calc(${theme.spacing(8)} + 1px)`,
//   },
// });

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   padding: theme.spacing(0, 1),
//   // necessary for content to be below app bar
//   ...theme.mixins.toolbar,
// }));

// const AppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   zIndex: theme.zIndex.drawer + 1,
//   transition: theme.transitions.create(["width", "margin"], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

// const Drawer = styled(MuiDrawer, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   width: drawerWidth,
//   flexShrink: 0,
//   whiteSpace: "nowrap",
//   boxSizing: "border-box",
//   ...(open && {
//     ...openedMixin(theme),
//     "& .MuiDrawer-paper": openedMixin(theme),
//   }),
//   ...(!open && {
//     ...closedMixin(theme),
//     "& .MuiDrawer-paper": closedMixin(theme),
//   }),
// }));

// export default function PortalLayout({ children }) {
//   const theme = useTheme();
//   const [open, setOpen] = React.useState(true);

//   const handleDrawer = () => {
//     setOpen(!open);
//   };
//   const route = useNavigate();
//   const location = useLocation();

//   const [isOpen, setIsOpen] = React.useState(false);

//   const toggleMenu = () => {
//     setIsOpen(!isOpen);
//   };
//   const [out, setOut] = React.useState();
//   const handleClick = () => setOut(!open);

//   const [open1, setOpen1] = useState([
//     false,
//     false,
//     false,
//     false,
//     false,
//     false,
//     false,
//     false,
//   ]);

//   const handleSelection = (index) => {
//     let op = [...open1];
//     op[index] = !op[index];
//     setOpen1(op);
//   };

//   // const [auth, setAuth] = useState(
//   //   sessionStorage.getItem(SESSION_IS_AUTHENTICATED)
//   // );
//   // console.log(auth);
//   const navigate = useNavigate();

//   // useEffect(() => {
//   //   if (auth === "false") {
//   //     route("/login");
//   //   }
//   // }, []);

//   const handleLogout = () => {
//     localStorage.removeItem('user')
//     Cookies.remove('Q0FUSU9OOQUNVU1RPTUVSLUFVVEhFTlRJIMSLQ1JFVC1LR=')
//     toast.success("Logout Successfully")
//     navigate('/login', { replace: true });
//   }

//   const [userEmail, setUserEmail] = useState("");

//   useEffect(() => {
//     const email = sessionStorage.getItem("userEmail");
//     if (email) {
//       setUserEmail(email);
//     }
//   }, []);

//   //const dispatch = useDispatch();
//   console.log("user info", sessionStorage.getItem(SESSION_USERINFO));

//   return (
//     <>
//       {location.pathname === "/login" ? (
//         children
//       ) : (
//         <>
//           <div className=" !flex !items-center">
//             <CssBaseline />
//             <AppBar
//               className={`!bg-white    !rounded-3xl !shadow-none mt-[-7px] ${
//                 open ? `!w-[84%]"` : `!w-[94%]`
//               }`}
//               sx={{ boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)" }}
//               open={open}
//             >
//               <Toolbar>
//                 <IconButton
//                   aria-label="open drawer"
//                   onClick={handleDrawer}
//                   edge="start"
//                   sx={{ marginLeft: 1 }}
//                 >
//                   <MenuIcon className="text-gray-600 mt-[4px] " />
//                 </IconButton>

//                 <div className="ml-auto flex gap-2 items-center">
//                   {/* <NotificationsIcon
//                     className="text-gray-600 "
//                     sx={{ fontSize: 20 }}
//                   /> */}

//                   <div className="flex items-center gap-2">
//                     <AccountCircleIcon
//                       className="text-gray-600 "
//                       sx={{ fontSize: 22 }}
//                     />
//                     <Popover className="ml-auto">
//                       <Popover.Button
//                         onClick={toggleMenu}
//                         className="flex gap-2 outline-none md:mr-6 cursor-pointer text-gray-700"
//                       >
//                         <IoIosArrowDown
//                           className={`w-4 h-4 ${
//                             isOpen
//                               ? "-rotate-180 duration-300"
//                               : "rotate-0 duration-300"
//                           }    `}
//                         />
//                       </Popover.Button>
//                       <Transition
//                         as={React.Fragment}
//                         enter="transition ease-out duration-100"
//                         enterFrom="transform scale-95"
//                         enterTo="transform scale-100"
//                         leave="transition ease-in duration-75"
//                         leaveFrom="transform scale-100"
//                         leaveTo="transform scale-95"
//                       >
//                         <Popover.Panel className="absolute right-10 bg-gray-50 border-2 border-gray-300 shadow-lg rounded-md  w-[150px] text-black">
//                           <div>
//                             <div
//                               className="flex text-gray-600 gap-6 p-2 cursor-pointer"
//                               onClick={() => handleLogout()}
//                             >
//                               <PowerSettingsNewIcon className="text-gray-600" />
//                               <h1>LogOut</h1>
//                             </div>
//                           </div>
//                         </Popover.Panel>
//                       </Transition>
//                     </Popover>
//                   </div>
//                 </div>
//               </Toolbar>
//             </AppBar>
//             <Drawer
//               variant="permanent"
//               open={open}
//               sx={{
//                 flexShrink: 0,
//                 "& .MuiDrawer-paper": {
//                   borderWidth: 0,
//                   boxSizing: "border-box",
//                   borderTopRightRadius: 40,
//                   borderBottomRightRadius: 40,
//                   backgroundColor: "#F9F9F9",
//                   zIndex: "9999",
//                   boxShadow: "4px 0px 10px rgba(0, 0, 0, 0.1)",
//                 },
//                 border: "none",
//               }}
//             >
//               <div>
//                 <img
//                   src={logo}
//                   alt=""
//                   className={`${
//                     open ? "w-[5rem]" : "w-[3rem]"
//                   }  ml-auto mr-auto my-4`}
//                 />
//               </div>

//               <div className="px-4">
         
//                 <ul className={`w-[100%]`}>

//                   <li>
//                     <div
//                       onClick={() => route("/account/addpurchase")}
//                       className={`flex items-center p-2 cursor-pointer  text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/account/addpurchase" ||
//                         location.pathname === "/account/addpurchase/add"
//                           ? "bg-gray-800 text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       }  ${open ? "ml-6" : "ml-0"}  `}
//                     >
//                       <Inventory2Icon
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/account/addpurchase"
//                             ? "bg-white text-gray-600"
//                             : ""
//                         } `}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/account/addpurchase"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600]  text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         New Purchase Medicine
//                       </span>
//                     </div>
//                   </li>
                  
//                   <li>
//                     <div
//                       onClick={() => route("/account/medicinestock")}
//                       className={`flex items-center p-2 cursor-pointer  text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/account/medicinestock" ||
//                         location.pathname === "/account/medicinestock/add"
//                           ? "bg-gray-800 text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       }  ${open ? "ml-6" : "ml-0"}  `}
//                     >
//                       <Inventory2Icon
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/account/medicinestock"
//                             ? "bg-white text-gray-600"
//                             : ""
//                         } `}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/account/purchasemedicine"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600]  text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         Medicine Stock
//                       </span>
//                     </div>
//                   </li>


//                   <li>
//                     <div
//                       onClick={() => route("/account/Labtest/labtest")}
//                       className={`flex items-center p-2 cursor-pointer  text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/account/Labtest/labtest" ||
//                         location.pathname === "/account/Labtest/labtest/add"
//                           ? "bg-gray-800 text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       }  ${open ? "ml-6" : "ml-0"}  `}
//                     >
//                       <Inventory2Icon
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/account/Labtest/labtest"
//                             ? "bg-white text-gray-600"
//                             : ""
//                         } `}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/account/Labtest/labtest/labtestservice"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600]  text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         Lab Test
//                       </span>
//                     </div>
//                   </li>

//                   <li>
//                     <div
//                       onClick={() => route("/account/medicalservices")}
//                       className={`flex items-center p-2 cursor-pointer  text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/account/medicalservices" ||
//                         location.pathname === "/account/medicalservices/add"
//                           ? "bg-gray-800 text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       }  ${open ? "ml-6" : "ml-0"}  `}
//                     >
//                       <Inventory2Icon
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/account/medicalservices"
//                             ? "bg-white text-gray-600"
//                             : ""
//                         } `}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/account/medicalservices"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600]  text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         Medical Services
//                       </span>
//                     </div>
//                   </li>


//                   <li>
//                     <div
//                       onClick={() => route("/account/sales")}
//                       className={`flex items-center p-2 cursor-pointer  text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/account/sales" ||
//                         location.pathname === "/account/sales/add"
//                           ? "bg-gray-800 text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       }  ${open ? "ml-6" : "ml-0"}  `}
//                     >
//                       <Inventory2Icon
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/account/sales"
//                             ? "bg-white text-gray-600"
//                             : ""
//                         } `}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/account/sales"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600]  text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         Medicine Sales
//                       </span>
//                     </div>
//                   </li>

//                   <li>
//                     <div
//                       onClick={() => route("/account/servicesales")}
//                       className={`flex items-center p-2 cursor-pointer  text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/account/servicesales" ||
//                         location.pathname === "/account/servicesales/add"
//                           ? "bg-gray-800 text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       }  ${open ? "ml-6" : "ml-0"}  `}
//                     >
//                       <Inventory2Icon
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/account/servicesales"
//                             ? "bg-white text-gray-600"
//                             : ""
//                         } `}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/account/servicesales"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600]  text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         Service Sales
//                       </span>
//                     </div>
//                   </li>

//                   <li>
//                     <div
//                       onClick={() => route("/account/patientsales")}
//                       className={`flex items-center p-2 cursor-pointer  text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/account/patientsales" ||
//                         location.pathname === "/account/patientsales/add"
//                           ? "bg-gray-800 text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       }  ${open ? "ml-6" : "ml-0"}  `}
//                     >
//                       <Inventory2Icon
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/account/patientsales"
//                             ? "bg-white text-gray-600"
//                             : ""
//                         } `}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/account/patientsales"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600]  text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         Patient Sales
//                       </span>
//                     </div>
//                   </li>



//                   <li>
//                     <div
//                       onClick={() => route("/account/income")}
//                       className={`flex items-center p-2 cursor-pointer  text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/account/income" ||
//                         location.pathname === "/account/income/AddEditIncome"
//                           ? "bg-gray-800 text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       }  ${open ? "ml-6" : "ml-0"}  `}
//                     >
//                       <CleanHandsIcon
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/account/income"
//                             ? "bg-white text-gray-600"
//                             : ""
//                         } `}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/account/income"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600]  text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         Income
//                       </span>
//                     </div>
//                   </li>

//                   <li>
//                     <div
//                       onClick={() => route("/account/expense")}
//                       className={`flex items-center p-2 cursor-pointer  text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/account/expense" ||
//                         location.pathname === "/account/expense/add"
//                           ? "bg-gray-800 text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       }  ${open ? "ml-6" : "ml-0"}  `}
//                     >
//                       <PaidIcon
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/account/expense"
//                             ? "bg-white text-gray-600"
//                             : ""
//                         } `}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/account/expense"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600]  text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         Expense
//                       </span>
//                     </div>
//                   </li>

//               {/* <li>
//                     <div
//                       onClick={() => route("/account/profitloss")}
//                       className={`flex items-center p-2 cursor-pointer  text-gray-600 mt-3 h-[2.6rem] ${
//                         location.pathname === "/account/profitloss" ||
//                         location.pathname === "/account/profitloss/add"
//                           ? "bg-gray-800 text-white mr-2 rounded-md font-[600]"
//                           : " mr-2 rounded-md"
//                       }  ${open ? "ml-6" : "ml-0"}  `}
//                     >
//                       <Inventory2Icon
//                         className={`!text-5xl ${
//                           open ? "mr-4" : "mr-auto ml-2 hover:!text-[3.5rem]"
//                         } rounded-full p-[12px] ml-[-1.2rem] ${
//                           location.pathname === "/account/profitloss"
//                             ? "bg-white text-gray-600"
//                             : ""
//                         } `}
//                         sx={{
//                           boxShadow:
//                             location.pathname === "/account/profitloss"
//                               ? "2px 5px 10px rgba(0, 0, 0, 0.2)"
//                               : "",
//                         }}
//                       />
//                       <span
//                         className={`flex-1 font-[600]  text-left ml-[2px] text-[13px] ${
//                           !open ? "hidden" : "block"
//                         }`}
//                       >
//                         Profit Loss Head
//                       </span>
//                     </div>
//                   </li>  */}
                  
//                 </ul> 
//               </div>
//             </Drawer>
//             <Box component="main" sx={{ flexGrow: 1, p: 0 }}>
//               <DrawerHeader />

//               <div
//                 className={`${
//                   location.pathname === "/login" || location.pathname === "/"
//                     ? "p-4"
//                     : "bg-gray-100 min-h-[80vh]  p-6 rounded-xl m-4"
//                 } `}
//               >
//                 {children}
//               </div>
//             </Box>
//           </div>
//         </>
//       )}
//     </>
//   );
// }


import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../assets/logo.png";
import Cookies from "js-cookie";
import toast from "react-hot-toast";

import { Popover, Transition } from "@headlessui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { FaRegUser } from "react-icons/fa";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CleanHandsIcon from "@mui/icons-material/CleanHands";
import PaidIcon from "@mui/icons-material/Paid";
import BuildIcon from "@mui/icons-material/Build";

import {
  SESSION_IS_AUTHENTICATED,
  SESSION_USERINFO,
} from "../Utills/Constants";

/* ─── constants ─────────────────────────────────────────────────────── */
const drawerWidth = 240;

/* ─── MUI styled helpers ─────────────────────────────────────────────── */
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "fixed !important",
  top: 8,
  right: 8,
  zIndex: theme.zIndex.drawer + 1,
  width: open
    ? `calc(100% - ${drawerWidth}px - 16px)`
    : `calc(100% - ${theme.spacing(8)} - 1px - 16px)`,
  marginLeft: open ? drawerWidth : `calc(${theme.spacing(8)} + 1px)`,
  background: "transparent !important",
  boxShadow: "none !important",
  transition: theme.transitions.create(["width", "margin-left"], {
    easing: theme.transitions.easing.sharp,
    duration: open
      ? theme.transitions.duration.enteringScreen
      : theme.transitions.duration.leavingScreen,
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

/* ─── nav items ──────────────────────────────────────────────────────── */
const navItems = [
  {
    label: "New Purchase Medicine",
    path: "/account/addpurchase",
    activePaths: ["/account/addpurchase", "/account/addpurchase/add"],
    icon: Inventory2Icon,
    activeBg: "bg-orange-400",
    activeBar: "#f97316",
    glow: "shadow-[0_4px_14px_rgba(249,115,22,0.5)]",
  },
  {
    label: "Medicine Stock",
    path: "/account/medicinestock",
    activePaths: ["/account/medicinestock", "/account/medicinestock/add"],
    icon: Inventory2Icon,
    activeBg: "bg-orange-400",
    activeBar: "#f97316",
    glow: "shadow-[0_4px_14px_rgba(249,115,22,0.5)]",
  },
  {
    label: "Lab Test",
    path: "/account/Labtest/labtest",
    activePaths: ["/account/Labtest/labtest", "/account/Labtest/labtest/add"],
    icon: Inventory2Icon,
    activeBg: "bg-orange-400",
    activeBar: "#f97316",
    glow: "shadow-[0_4px_14px_rgba(249,115,22,0.5)]",
  },
  {
    label: "Medical Services",
    path: "/account/medicalservices",
    activePaths: ["/account/medicalservices", "/account/medicalservices/add"],
    icon: Inventory2Icon,
    activeBg: "bg-orange-400",
    activeBar: "#f97316",
    glow: "shadow-[0_4px_14px_rgba(249,115,22,0.5)]",
  },
  {
    label: "Medicine Sales",
    path: "/account/sales",
    activePaths: ["/account/sales", "/account/sales/add"],
    icon: Inventory2Icon,
    activeBg: "bg-orange-400",
    activeBar: "#f97316",
    glow: "shadow-[0_4px_14px_rgba(249,115,22,0.5)]",
  },
  {
    label: "Service Sales",
    path: "/account/servicesales",
    activePaths: ["/account/servicesales", "/account/servicesales/add"],
    icon: Inventory2Icon,
    activeBg: "bg-orange-400",
    activeBar: "#f97316",
    glow: "shadow-[0_4px_14px_rgba(249,115,22,0.5)]",
  },
  {
    label: "Patient Sales",
    path: "/account/patientsales",
    activePaths: ["/account/patientsales", "/account/patientsales/add"],
    icon: Inventory2Icon,
    activeBg: "bg-orange-400",
    activeBar: "#f97316",
    glow: "shadow-[0_4px_14px_rgba(249,115,22,0.5)]",
  },
  {
    label: "Income",
    path: "/account/income",
    activePaths: ["/account/income", "/account/income/AddEditIncome"],
    icon: CleanHandsIcon,
    activeBg: "bg-orange-400",
    activeBar: "#f97316",
    glow: "shadow-[0_4px_14px_rgba(249,115,22,0.5)]",
  },
  {
    label: "Expense",
    path: "/account/expense",
    activePaths: ["/account/expense", "/account/expense/add"],
    icon: PaidIcon,
    activeBg: "bg-orange-400",
    activeBar: "#f97316",
    glow: "shadow-[0_4px_14px_rgba(249,115,22,0.5)]",
  },
  {
    label: "Equipments",
    path: "/account/equipment",
    activePaths: [
      "/account/equipment",
      "/account/equipment/add",
      "/account/equipment/update",
    ],
    icon: BuildIcon,
    activeBg: "bg-orange-400",
    activeBar: "#f97316",
    glow: "shadow-[0_4px_14px_rgba(249,115,22,0.5)]",
  },
];

/* ══════════════════════════════════════════════════════════════════════ */
export default function PortalLayout({ children }) {
  const [open, setOpen] = useState(true);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  console.log("user info", sessionStorage.getItem(SESSION_USERINFO));

  const handleLogout = () => {
    localStorage.removeItem("user");
    Cookies.remove("Q0FUSU9OOQUNVU1RPTUVSLUFVVEhFTlRJIMSLQ1JFVC1LR=");
    toast.success("Logout Successfully");
    navigate("/login", { replace: true });
  };

  if (location.pathname === "/" || location.pathname === "/login")
    return children;

  /* derive page title from active nav item */
  const activeItem = navItems.find((item) =>
    item.activePaths.includes(location.pathname)
  );
  const pageTitle = activeItem?.label ?? "Dashboard";

  return (
    <div className="flex items-stretch min-h-screen bg-slate-100">
      {/* Google Font */}
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap'); * { font-family: 'Plus Jakarta Sans', sans-serif; }`}</style>

      <CssBaseline />

      {/* ── TOP BAR ─────────────────────────────────────────────────── */}
      <AppBar open={open}>
        <div className="rounded-2xl border border-white/70 bg-white/85 backdrop-blur-xl shadow-[0_4px_24px_rgba(0,0,0,0.08)]">
          <Toolbar className="!min-h-[56px] !px-3">
            {/* Menu toggle */}
            <IconButton
              onClick={() => setOpen(!open)}
              edge="start"
              className="!mr-2 !w-9 !h-9 !rounded-xl !bg-gray-700/[0.07] hover:!bg-gray-700/[0.14] !transition-colors"
            >
              <MenuIcon className="!text-[20px] !text-gray-700" />
            </IconButton>

            {/* Page title */}
            <div className="ml-2">
              <p className="text-[15px] font-bold text-gray-700 m-0 leading-tight">
                {pageTitle}
              </p>
              <p className="text-[11px] text-gray-400 m-0">
                {new Date().toLocaleDateString("en-US", {
                  weekday: "long",
                  month: "short",
                  day: "numeric",
                })}
              </p>
            </div>

            {/* Right controls */}
            <div className="ml-auto flex items-center gap-3">
              <Popover className="relative">
                <Popover.Button
                  as="div"
                  onClick={() => setIsPopoverOpen(!isPopoverOpen)}
                  className="flex items-center gap-2 px-3 py-[6px] rounded-full cursor-pointer select-none
                    bg-gradient-to-r from-gray-700 to-gray-500
                    shadow-[0_2px_12px_rgba(100,116,139,0.25)]
                    hover:shadow-[0_4px_20px_rgba(100,116,139,0.38)] transition-shadow duration-200"
                >
                  <AccountCircleIcon className="!text-[20px] !text-white/90" />
                  <IoIosArrowDown
                    className="w-3.5 h-3.5 text-white/70 transition-transform duration-300"
                    style={{
                      transform: isPopoverOpen
                        ? "rotate(-180deg)"
                        : "rotate(0deg)",
                    }}
                  />
                </Popover.Button>

                <Transition
                  as={React.Fragment}
                  enter="transition ease-out duration-150"
                  enterFrom="opacity-0 -translate-y-2"
                  enterTo="opacity-100 translate-y-0"
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100 translate-y-0"
                  leaveTo="opacity-0 -translate-y-2"
                >
                  <Popover.Panel
                    className="absolute top-[calc(100%+10px)] right-0 z-[9999]
                      min-w-[220px] rounded-2xl overflow-hidden
                      bg-white/[0.97] backdrop-blur-xl
                      border border-gray-700/10
                      shadow-[0_20px_60px_rgba(0,0,0,0.15)]"
                  >
                    {/* Header */}
                    <div className="flex items-center gap-2.5 p-4 bg-gradient-to-r from-gray-700 to-gray-500">
                      <div className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                        <FaRegUser className="text-white text-base" />
                      </div>
                      <div>
                        <p className="text-white text-[14px] font-semibold m-0">
                          Accounts
                        </p>
                        <p className="text-white/60 text-[11px] m-0">
                          {sessionStorage.getItem("userEmail") || ""}
                        </p>
                      </div>
                    </div>

                    {/* Logout */}
                    <div
                      onClick={handleLogout}
                      className="flex items-center gap-2.5 m-2.5 px-3.5 py-2.5 rounded-xl cursor-pointer
                        bg-gradient-to-r from-red-500 to-red-600
                        text-white font-semibold text-[13px]
                        shadow-[0_3px_12px_rgba(239,68,68,0.3)]
                        hover:-translate-y-px hover:shadow-[0_6px_18px_rgba(239,68,68,0.4)]
                        transition-all duration-200"
                    >
                      <PowerSettingsNewIcon className="!text-[18px]" />
                      <span>Sign Out</span>
                    </div>
                  </Popover.Panel>
                </Transition>
              </Popover>
            </div>
          </Toolbar>
        </div>
      </AppBar>

      {/* ── SIDEBAR ─────────────────────────────────────────────────── */}
      <Drawer
        variant="permanent"
        open={open}
        sx={{
          "& .MuiDrawer-paper": {
            border: "none",
            borderTopRightRadius: 24,
            borderBottomRightRadius: 24,
            background:
              "linear-gradient(160deg, #1e1b2e 0%, #1e1b2e 50%, #2d3a4a 90%, #374151 100%)",
            boxShadow: "6px 0 32px rgba(0,0,0,0.22)",
            overflow: "hidden",
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        {/* Radial ambient overlay */}
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse at 20% 15%, rgba(156,163,175,0.18) 0%, transparent 55%), radial-gradient(ellipse at 75% 85%, rgba(107,114,128,0.22) 0%, transparent 55%)",
          }}
        />

        {/* Logo */}
        <div className="relative flex items-center justify-center px-3 pt-5 pb-4 border-b border-white/[0.08] mb-2 flex-shrink-0">
          <img
            src={logo}
            alt="logo"
            className="object-contain transition-all duration-300"
            style={{ width: open ? 80 : 32 }}
          />
        </div>

        {/* Section label */}
        {open && (
          <p className="relative text-[10px] font-bold tracking-[1.2px] uppercase text-white/30 px-5 pt-2 pb-1 m-0 flex-shrink-0">
            Navigation
          </p>
        )}

        {/* Nav — scrollable */}
        <nav
          className="relative py-1 flex-1"
          style={{ overflowY: "auto", overflowX: "hidden" }}
        >
          {navItems.map((item) => {
            const isActive = item.activePaths.includes(location.pathname);
            const Icon = item.icon;
            return (
              <div
                key={item.path}
                onClick={() => navigate(item.path)}
                title={!open ? item.label : ""}
                className={[
                  "relative flex items-center cursor-pointer rounded-xl overflow-hidden",
                  "mx-2 my-1 px-3 py-2.5",
                  "transition-all duration-[250ms] ease-[cubic-bezier(.4,0,.2,1)]",
                  isActive
                    ? "text-white bg-white/[0.12] shadow-[0_4px_20px_rgba(0,0,0,0.2),inset_0_0_0_1px_rgba(255,255,255,0.15)]"
                    : "text-white/60 hover:text-white/95 hover:bg-white/[0.08]",
                ].join(" ")}
              >
                {/* Icon wrap */}
                <div
                  className={[
                    "flex items-center justify-center w-[34px] h-[34px] rounded-[9px] flex-shrink-0 transition-all duration-[250ms]",
                    isActive
                      ? `${item.activeBg} ${item.glow}`
                      : "bg-white/10 hover:bg-white/[0.16]",
                  ].join(" ")}
                >
                  <Icon
                    sx={{
                      fontSize: 18,
                      color: isActive ? "#fff" : "rgba(255,255,255,0.75)",
                    }}
                  />
                </div>

                {/* Label */}
                <span
                  className={[
                    "ml-3 text-[13px] font-semibold whitespace-nowrap overflow-hidden transition-all duration-300",
                    open ? "max-w-[160px] opacity-100" : "max-w-0 opacity-0",
                  ].join(" ")}
                >
                  {item.label}
                </span>

                {/* Active bar */}
                {isActive && (
                  <div
                    className="absolute right-0 top-1/2 -translate-y-1/2 w-[3px] h-[60%] rounded-l"
                    style={{ background: item.activeBar }}
                  />
                )}
              </div>
            );
          })}
        </nav>
      </Drawer>

      {/* ── MAIN CONTENT ────────────────────────────────────────────── */}
      <Box component="main" sx={{ flexGrow: 1, p: 0 }}>
        <DrawerHeader />
        <div className="bg-gradient-to-br from-gray-50 to-gray-100 min-h-[calc(100vh-80px)] p-4 mr-2 mb-2 rounded-2xl shadow-[0_2px_16px_rgba(0,0,0,0.06)]">
          {children}
        </div>
      </Box>
    </div>
  );
}